import {
  AnalysisEntityCacheType,
  CommunityEntity,
  PortfolioEntity,
} from './type';

export const isSameAnalysisEntity = (
  current: AnalysisEntityCacheType | null,
  next: AnalysisEntityCacheType | null
): boolean => {
  if (!current || !next) {
    return false;
  }

  if (current.type !== next.type) {
    return false;
  }

  if (current.type === 'community') {
    return current.community.id === (next as CommunityEntity)?.community.id;
  }

  if (current.type === 'portfolio') {
    return current.portfolio.id === (next as PortfolioEntity).portfolio.id;
  }

  return false;
};
